import React, { Component } from "react";
import { Radio, CircularProgress, FormControlLabel, RadioGroup, Grid, Icon, Select, MenuItem, List, Fab, Button, DialogContent, ListItemText, ListItemAvatar, DialogTitle, Avatar, Card, ListItem } from "@material-ui/core";

import FontAwesome from "react-fontawesome";
import { Link } from "react-router-dom";

import moment from 'moment';
import 'moment-timezone';//timezone

import { connect } from "react-redux";
import { compose } from 'redux';
import * as actions from '../../../store/actions/index';
class MyOpenTasks extends Component {
  state = {
    tasklist: [],
    showMore: false,
    value_type: "true",
    limit: 5,
    totalPages: 0,
    currentPage: 1,
    isDataLoading: true,
    hasMore: false,
    pagesLoaded: [],
    memberid: 0,
    dateformat: 'MM/DD/YYYY',
    timeZone: 'America/New_York',
  };

  componentDidMount() {
    let val = {
      limit: parseFloat(this.state.limit),
      pageno: parseFloat(this.state.currentPage),
      ismytask: (this.state.value_type == "true"),
      memberid: 0
    }
    this.props.taskReportList(this.props.apolloClient.client, val);
  }

  componentWillReceiveProps(props) {
    if (props.settingReducer.userSettingArray && props.settingReducer.userSettingArray.data) {
      let usersetting = props.settingReducer.userSettingArray.data;

      let format = usersetting.dateformat;
      let timezone = usersetting.timezone;
      this.setState({ dateformat: format, timeZone: timezone })
    }

    if (props.reportReducer.opentaskreportdata && props.reportReducer.opentaskreportdata.data && props.reportReducer.opentaskreportdata.data) {
      console.log("MyOpenTasks API response:", props.reportReducer.opentaskreportdata.data);
      let tasklist = props.reportReducer.opentaskreportdata.data.data.task;
      let totalpage = props.reportReducer.opentaskreportdata.data.data.totalpage;


      if (this.state.currentPage === 1) {
        this.setState({
          tasklist: tasklist,
          isDataLoading: false,
          hasMore: totalpage > this.state.currentPage ? true : false,
          totalPages: totalpage
        }, () => this.forceUpdate())
      } else {
        if (this.state.pagesLoaded.indexOf(this.state.currentPage) == -1) {
          this.AddNewData(tasklist)
        }
        this.setState({
          hasMore: totalpage > this.state.currentPage ? true : false,
          isDataLoading: false,
        }, () => this.forceUpdate())
      }

    }
    else {
      setTimeout(() => {
        this.setState({ isDataLoading: false, });
      }, 1500);
    }
    if (props.reportReducer.UserDashboardId) {
      if (this.state.memberid !== props.reportReducer.UserDashboardId) {
        {
          this.setState({
            memberid: props.reportReducer.UserDashboardId
          }, () => this.updateGraphSettings())
        }
      }
    }
  }
  componentDidUpdate(PrevProps) {
    if (PrevProps.reportReducer.UserDashboardId !== this.props.reportReducer.UserDashboardId) {
      this.setState({
        memberid: this.props.reportReducer.UserDashboardId
      }, () => this.updateGraphSettings())
    }
  }
  fetchMoreData = () => {
    // e.preventDefault();
    if (this.state.currentPage >= this.state.totalPages) {
      this.setState({ hasMore: false });
      return;
    }
    this.getNextPageData(this.state.currentPage + 1)
  };

  getNextPageData = (page) => {
    this.setState({
      currentPage: page, isDataLoading: true
    }, () => this.updateGraphSettings())
  }

  AddNewData = (taskdata) => {
    let pagesLoaded = this.state.pagesLoaded;
    var okData = [...this.state.tasklist]
    okData = [...this.state.tasklist, ...taskdata];
    pagesLoaded.push(this.state.currentPage);
    this.setState({ tasklist: okData, pagesLoaded })
  }

  handleTypeChange = (event) => {
    this.setState({
      value_type: event.target.value
    }, () => this.updateGraphSettings())
  }
  updateGraphSettings = () => {
    let val = {
      ismytask: (this.state.value_type == "true"),
      limit: parseFloat(this.state.limit),
      pageno: parseFloat(this.state.currentPage),
      memberid: parseFloat(this.state.memberid)
    }
    this.props.taskReportList(this.props.apolloClient.client, val);
  }
  render() {
    let { hasMore, isDataLoading, value_type, tasklist } = this.state;
    
    // Premium Glassmorphic Styles
    const cardStyle = {
      height: "500px",
      display: "flex",
      flexDirection: "column",
      background: "linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(240, 248, 255, 0.8))",
      backdropFilter: "blur(16px)",
      borderRadius: "20px",
      border: "1px solid rgba(255, 255, 255, 0.6)",
      boxShadow: "0 10px 40px -10px rgba(31, 38, 135, 0.1)",
      overflow: "hidden",
      marginBottom: "28px"
    };

    const headerStyle = {
      padding: "16px 24px",
      background: "linear-gradient(90deg, rgba(0, 150, 136, 0.08), rgba(3, 169, 244, 0.05))",
      borderBottom: "1px solid rgba(0, 0, 0, 0.03)"
    };

    const titleStyle = {
      margin: 0,
      fontSize: "1.3rem",
      fontWeight: 700,
      color: "#00796B",
      fontFamily: "'Inter', sans-serif",
      letterSpacing: "-0.01em"
    };

    const linkStyle = {
      color: "#0288D1",
      textDecoration: "none",
      fontWeight: 600,
      fontSize: "0.85rem",
      padding: "6px 12px",
      borderRadius: "8px",
      background: "rgba(3, 169, 244, 0.1)",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      gap: "4px"
    };

    const listItemStyle = {
      background: "#ffffff",
      borderRadius: "16px",
      margin: "12px 24px",
      padding: "18px 20px",
      border: "1px solid rgba(0, 0, 0, 0.04)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.02)",
      transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
      cursor: "pointer",
    };

    const iconFabStyle = {
      background: "linear-gradient(135deg, #009688, #4DB6AC)",
      color: "white",
      boxShadow: "0 6px 12px rgba(0, 150, 136, 0.25)",
      width: "44px",
      height: "44px",
      minHeight: "44px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    return (
      <Card elevation={0} style={cardStyle} >
        <div style={headerStyle}>
          <Grid container justify="space-between" alignItems="center">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <h3 style={titleStyle}>My Open Tasks</h3>
              <RadioGroup row aria-label="gender" name="value_type" value={value_type} onChange={this.handleTypeChange} style={{ marginLeft: "16px" }}>
                <FormControlLabel 
                  value={"true"} 
                  control={<Radio style={{color: "#009688", padding: "4px"}} size="small" />} 
                  label={<span style={{fontSize: "0.85rem", color: "#455a64", fontWeight: 600}}>My Tasks</span>} 
                  style={{margin: 0}}
                />
              </RadioGroup>
            </div>
            <Link 
              style={linkStyle} 
              to="/task/task-list" 
              onMouseOver={(e) => { e.currentTarget.style.background="rgba(3, 169, 244, 0.2)"; e.currentTarget.style.transform="translateY(-1px)" }} 
              onMouseOut={(e) => { e.currentTarget.style.background="rgba(3, 169, 244, 0.1)"; e.currentTarget.style.transform="none" }}
            >
              View All <Icon style={{fontSize: "1.1rem"}}>arrow_forward</Icon>
            </Link>
          </Grid>
        </div>

        <div className="v_scroll position-relative" style={{ flex: 1, paddingBottom: '20px', overflowY: 'auto' }}>
          <List className="white_space_nowrap" style={{paddingTop: '8px'}}>
            {
              (tasklist.length > 0) ?
                <>
                  {
                    tasklist.map((fieldData, index) => (
                      <div 
                        key={index} 
                        style={listItemStyle} 
                        onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(0, 150, 136, 0.1)'; e.currentTarget.style.borderColor = "rgba(0, 150, 136, 0.2)"; }} 
                        onMouseOut={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.02)'; e.currentTarget.style.borderColor = "rgba(0, 0, 0, 0.04)"; }}
                      >
                        <Grid container justify="space-between" alignItems="center" spacing={2}>
                          <Grid item xs={2} sm={1} style={{display: 'flex', justifyContent: 'center'}}>
                            <Fab size="small" style={iconFabStyle}>
                              <Icon style={{fontSize: "1.5rem"}}>check</Icon>
                            </Fab>
                          </Grid>
                          <Grid item xs={10} sm={4}>
                            <ListItemText
                              primary={<div style={{ fontWeight: 600, color: "#263238", fontSize: "1.05rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: '100%', marginBottom: '4px' }}>{fieldData.name && fieldData.name}</div>}
                              secondary={<div style={{ color: "#607d8b", fontSize: "0.85rem", display: 'flex', alignItems: 'center' }}><Icon style={{fontSize: '1.1rem', marginRight: '6px', color: '#90a4ae'}}>person</Icon>{fieldData.owner && fieldData.owner[0].name}</div>}
                            />
                          </Grid>
                          <Grid item xs={12} sm={7}>
                            <ListItemText
                              primary={<div style={{ fontWeight: 500, color: "#455a64", fontSize: "0.95rem", marginBottom: '4px', display: 'flex', alignItems: 'center' }}><Icon style={{fontSize: '1.1rem', marginRight: '6px', color: '#009688'}}>event</Icon> Due: <span style={{marginLeft: '6px', color: '#00796b', fontWeight: 600}}>{fieldData.duedate && moment.unix(fieldData.duedate).tz(this.state.timeZone).format(this.state.dateformat)}</span></div>}
                              secondary={<div style={{ color: "#607d8b", fontSize: "0.85rem", display: 'flex', alignItems: 'center' }}><Icon style={{fontSize: '1.1rem', marginRight: '6px', color: '#90a4ae'}}>link</Icon> Associated with: <span style={{marginLeft: '4px', color: '#455a64'}}>{fieldData.relatedto && fieldData.relatedto[0].value}</span></div>}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    ))
                  }
                  {
                    isDataLoading ?
                      <Grid container spacing={0} direction="column" alignItems="center" justify="center" style={{ minHeight: '15vh', backgroundColor: 'transparent' }}>
                        <Grid item xs={3}>
                          <CircularProgress disableShrink size={28} style={{color: "#009688"}} />
                        </Grid>
                      </Grid>
                      :
                      (hasMore) &&
                      <Grid container item justify="center" style={{ margin: "24px 0 8px 0" }}>
                        <Button 
                          variant="outlined" 
                          style={{ color: '#009688', borderColor: 'rgba(0, 150, 136, 0.4)', borderRadius: '24px', padding: '8px 24px', textTransform: 'none', fontWeight: 600, background: 'rgba(0, 150, 136, 0.03)' }}
                          onClick={this.fetchMoreData}
                          endIcon={<Icon>expand_more</Icon>}
                          onMouseOver={(e) => { e.currentTarget.style.background="rgba(0, 150, 136, 0.08)"; }}
                          onMouseOut={(e) => { e.currentTarget.style.background="rgba(0, 150, 136, 0.03)"; }}
                        >
                          Load More Tasks
                        </Button>
                      </Grid>
                  }
                </>
                :
                <div style={{ textAlign: "center", color: "#90a4ae", fontWeight: 500, margin: "60px 0" }}>
                  <Icon style={{ fontSize: "3.5rem", color: "#cfd8dc", marginBottom: "16px" }}>task_alt</Icon>
                  <div style={{fontSize: "1.1rem", color: "#78909c"}}>No open tasks found. You're all caught up!</div>
                </div>
            }
          </List>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = state => {
  return {
    settingReducer: state.settingReducer,
    apolloClient: state.apolloClient,
    notification: state.notification,
    reportReducer: state.reportReducer,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    // getPipelines: (client) => dispatch(actions.getPipelines(client)),
    // getTagsList: (client) => dispatch(actions.getTagsList(client)),
    // getUserList: (client) => dispatch(actions.getUserList(client)),
    // getActivityTypes: (client) => dispatch(actions.getActivityTypes(client)),
    // customFieldList: (client, value) => dispatch(actions.customFieldList(client, value)),

    taskReportList: (client, value) => dispatch(actions.taskReportList(client, value)),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(MyOpenTasks);
